'use strict';

/*
 * Allows playing with all kind of flexbox attributes
 */

class PlayFlexbox {

    // instantiate object
    constructor() {
        this.playContainer = document.querySelector('.play-container');

        // if we are not playing with flexbox return immediately
        if (this.playContainer == null)
            return;

        this.cardA = document.querySelector('.card-a');
        this.cardB = document.querySelector('.card-b');
        this.flexContainerButtons = document.querySelectorAll('.flex-container');
        this.playElementButtonsAHeight = document.querySelectorAll('.flex-element-A-height');
        this.playElementButtonsAWidth = document.querySelectorAll('.flex-element-A-width');
        this.playElementButtonsBHeight = document.querySelectorAll('.flex-element-B-height');
        this.playElementButtonsBWidth = document.querySelectorAll('.flex-element-B-width');
        this.justifyContentButtons = document.querySelectorAll('.justify-content');
        this.flexDirectionButtons = document.querySelectorAll('.flex-direction');
        this.alignItemsButtons = document.querySelectorAll('.align-items');

        this.events();
    }

    // event listeners
    events() {
        this.flexContainerButtons.forEach(el =>
            el.addEventListener('click', this.applyFlexContainer.bind(this))
        );
        this.playElementButtonsAHeight.forEach(el =>
            el.addEventListener('click', this.applyContainerElementsAHeight.bind(this))
        );
        this.playElementButtonsAWidth.forEach(el =>
            el.addEventListener('click', this.applyContainerElementsAWidth.bind(this))
        );
        this.playElementButtonsBHeight.forEach(el =>
            el.addEventListener('click', this.applyContainerElementsBHeight.bind(this))
        );
        this.playElementButtonsBWidth.forEach(el =>
            el.addEventListener('click', this.applyContainerElementsBWidth.bind(this))
        );
        this.justifyContentButtons.forEach(el =>
            el.addEventListener('click', this.applyJustifyContent.bind(this))
        );
        this.flexDirectionButtons.forEach(el =>
            el.addEventListener('click', this.applyFlexDirection.bind(this))
        );
        this.alignItemsButtons.forEach(el =>
            el.addEventListener('click', this.applyAlignItems.bind(this))
        );
    }

    // methods
    applyFlexContainer(e) {
        this.playContainer.style.height = e.target.textContent;
        this.selectPlayButton(this.flexContainerButtons, e.target);
    };
    
    applyContainerElementsAHeight(e) {
        this.cardA.style.height = e.target.textContent;
        this.selectPlayButton(this.playElementButtonsAHeight, e.target);
    };
    applyContainerElementsAWidth(e) {
        this.cardA.style.width = e.target.textContent;
        this.selectPlayButton(this.playElementButtonsAWidth, e.target);
    };
    
    applyContainerElementsBHeight(e) {
        this.cardB.style.height = e.target.textContent;
        this.selectPlayButton(this.playElementButtonsBHeight, e.target);
    };
      
    applyContainerElementsBWidth(e) {
        this.cardB.style.width = e.target.textContent;
        this.selectPlayButton(this.playElementButtonsBWidth, e.target);
    };
    
    applyJustifyContent(e) {
        this.playContainer.style.justifyContent = e.target.textContent;
        this.selectPlayButton(this.justifyContentButtons, e.target);
    };
    
    applyFlexDirection(e) {
        this.playContainer.style.flexDirection = e.target.textContent;
        this.selectPlayButton(this.flexDirectionButtons, e.target);
    };
      
    applyAlignItems(e) {
        this.playContainer.style.alignItems = e.target.textContent;
        this.selectPlayButton(this.alignItemsButtons, e.target);
    };

    /* helper function */
    selectPlayButton = function (buttonList, button) {
        buttonList.forEach(el => {
            el.classList.remove("play-button--selected");
        });

        button.classList.add("play-button--selected");
    };
}

export default PlayFlexbox;